import { render, staticRenderFns } from "./Skus.vue?vue&type=template&id=5db206f4&scoped=true&"
import script from "./Skus.vue?vue&type=script&lang=js&"
export * from "./Skus.vue?vue&type=script&lang=js&"
import style0 from "./Skus.vue?vue&type=style&index=0&id=5db206f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db206f4",
  null
  
)

export default component.exports